"use client";
import {
  usePrivy,
  useLogin,
  useLogout,
  getAccessToken
} from "@privy-io/react-auth";
import {
  createSupabaseSession,
  destroySupabaseSession
} from "../utils/supabase/session";
import { useReadContract } from "wagmi";
import { coinageRead } from "../useCoinageContract";
import { useRouter } from "next/navigation";
export const handleSuccess = async (user: any, isNewUser: boolean) => {
  const wallet = user.wallet?.address as string;

  try {
    const privyAccessToken = await getAccessToken();
    await createSupabaseSession({
      privyAccessToken,
      wallet
    });

    return { success: true, isNewUser, wallet };
  } catch (error) {
    console.error("couldnt create auth session", error);
    return { error: true, errorMessage: error };
  }
};

export const useUser = () => {
  const router = useRouter();
  const { authenticated, user, ready } = usePrivy();
  const address = user?.wallet?.address;
  let isHolder = false;
  let holderClass = "none";

  const { logout: privyLogout } = useLogout({
    onSuccess: async () => {
      await destroySupabaseSession();
    }
  });

  const logout = () => {
    privyLogout();
  };

  type User = {};

  const { login } = useLogin({
    onComplete: async (user, isNewUser) => {
      await handleSuccess(user, isNewUser);
      console.log("onComplete", user);
      if (isNewUser) router.push("/coop/onboarding");
    },
    onError: error => {
      console.log("on privy error", error);
    }
  });

  const holderAddress = "0xb6Ae69b8Ef57161E06380a4817C05A5A81f7208e";
  const { data: membershipData, status } = useReadContract({
    ...coinageRead,
    functionName: "balanceOfBatch",
    args: [
      [address, address],
      [1, 2]
    ],
    query: {
      enabled: !!address
    }
  });

  if (status === "success") {
    const tokens = membershipData as number[];
    const hasNetworkToken = tokens?.[0] > 0;
    const hasTokens = tokens?.some(token => token > 0);
    isHolder = hasTokens;
    if (isHolder) {
      holderClass = hasNetworkToken ? "network" : "caucus";
    }
  }

  return {
    login,
    logout,
    authenticated: ready && authenticated,
    wallet: user?.wallet,
    ready,
    user,
    holder: {
      isHolder,
      class: holderClass,
      ready: address ? status === "success" : true
    }
  };
};
